/** Respuesta cruda de GET .../api/Promociones */
export interface PromocionesApiResponse {
  promocionUno?: string | null;
  promocionDos?: string | null;
  promocionTres?: string | null;
  primerPromocion?: string | null;
  segundaPromocion?: string | null;
  tercerPromocion?: string | null;
  id?: number;
  idUsuario?: number;
  nombre?: string;
  fechaHora?: string;
  estatus?: number;
  cintillo?: boolean;
}

/** Modelo normalizado para la plantilla del cintillo */
export interface Cintillo {
  id?: number;
  idUsuario?: number;
  nombre?: string;
  primerPromocion: string;
  fechaHora?: string;
  estatus?: number;
  segundaPromocion: string;
  tercerPromocion: string;
  cintillo?: boolean;
}

export function mapPromocionesApiToCintillo(raw: PromocionesApiResponse): Cintillo {
  return {
    id: raw.id,
    idUsuario: raw.idUsuario,
    nombre: raw.nombre,
    fechaHora: raw.fechaHora,
    estatus: raw.estatus,
    cintillo: raw.cintillo,
    primerPromocion: raw.primerPromocion ?? raw.promocionUno ?? '',
    segundaPromocion: raw.segundaPromocion ?? raw.promocionDos ?? '',
    tercerPromocion: raw.tercerPromocion ?? raw.promocionTres ?? ''
  };
}

export function hasCintilloPromocionesActivas(cintillo: Cintillo): boolean {
  return [cintillo.primerPromocion, cintillo.segundaPromocion, cintillo.tercerPromocion].every(
    (url) => typeof url === 'string' && url.trim().length > 0
  );
}
